<h4 mat-dialog-title class="modal-title text-center">
    {{ 'INVITE.TITLE' | translate }}
</h4>

<mat-dialog-content>
    <app-invite-form [idPlayer]="idPlayer"></app-invite-form>
</mat-dialog-content>
